import { render, staticRenderFns } from "./CampaignCuration.vue?vue&type=template&id=dc391e7c&"
import script from "./CampaignCuration.vue?vue&type=script&lang=js&"
export * from "./CampaignCuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports